import Axios from "axios";

const Request = Axios.create({
  // headers: {
  //     'Accept': '*/*',
  //     'Content-Type' : 'application/json'
  // },
  baseURL: process.env.VUE_APP_BASE_API,
});

// HTTP.defaults.withCredentials = true

Request.interceptors.response.use(
  (response) => {
    const res = response;
    if (res.status !== 200) {
      return res;
    } else {
      return res.data.code === 200 ? res.data.data : res.data;
    }
  },
  (error) => {
    error.response.data.message &&
      Toast(error.response.data.message || "网络出错，请重试");
    return Promise.reject(error);
  }
);

export default Request;
